import React, { useEffect } from 'react'
import './Alert.css'; // Optional external styles

const AlertMessage = ({ isVisible, onClose }) => {
    useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto'; // Restore on unmount
    };
  }, [isVisible]);
  if (!isVisible) return null;
  return (
     <div className="modal-overlay">
      <div className="modal-content max-[700px]:">
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        <h2 className="modal-title">🚫 No Linked Account</h2>
        <p className="modal-text">
          It looks like you don’t have a linked account.
          <br />
          To get access, please contact our support team:
        </p>
        <a href="mailto:SUPPORT@MyRxAdvantEdge.com" className="modal-email">
          SUPPORT@MyRxAdvantEdge.com
        </a>
      </div>
    </div>
  )
}

export default AlertMessage
